/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Button, rem, useMantineTheme } from '@mantine/core';
import { RiArrowLeftLine } from '@remixicon/react';
import { Link, type LinkProps } from 'react-router-dom';

import type { PropsWithChildren } from '@fai/util/types';

export default function TransparentBackLinkButton({
  to,
  children,
}: PropsWithChildren<{ to: LinkProps['to'] }>) {
  const theme = useMantineTheme();

  return (
    <Button
      to={to}
      component={Link}
      variant="transparent"
      size="sm"
      w="fit-content"
      h={rem(18)}
      c={theme.pf.color.fg.neutral.subtle}
      p={0}
      leftSection={<RiArrowLeftLine size={16} />}
    >
      {children}
    </Button>
  );
}

TransparentBackLinkButton.displayName = 'TransparentBackLinkButton';
